import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FaRegUser, FaRegBuilding, FaPhoneAlt, FaEnvelope, FaPen, FaRegFileAlt, FaShieldAlt, FaCheckCircle } from 'react-icons/fa';
import axios from 'axios';
import H1 from '../Images/Hma.jpeg';
import L1 from '../Images/logo-w.png';

const Form1 = () => {
    const [formData, setFormData] = useState({
        name: '',
        address: '',
        phone: '',
        email: '',
        chiefPromoter: '',
        designation: '',
        yearOfIncorporation: '',
        areasOfOperation: '',
        attendAwards: '',
        willingToSupplement: '',
        willingToPresent: '',
        writeUp: '',
        otherInfo: '',
        legalCompliance: {
            statutoryApprovals: false,
            noPFTaxLiabilities: false,
            noOffences: false,
            notNPA: false,
            noChildEmployment: false,
        },
        applicantName: '',
        applicantDesignation: '',
        applicantEmail: '',
        applicantPhone: '',
        signature: '',
    });

    const [signatureFile, setSignatureFile] = useState(null);

    const handleSignatureChange = (e) => {
        setSignatureFile(e.target.files[0]);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleCheckboxChange = (e) => {
        const { name } = e.target;
        setFormData({
            ...formData,
            legalCompliance: {
                ...formData.legalCompliance,
                statutoryApprovals: false,
                noPFTaxLiabilities: false,
                noOffences: false,
                notNPA: false,
                noChildEmployment: false,
                [name]: true,
            },
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const formDataToSend = new FormData();
        formDataToSend.append('name', formData.name);
        formDataToSend.append('address', formData.address);
        formDataToSend.append('phone', formData.phone);
        formDataToSend.append('email', formData.email);
        formDataToSend.append('chiefPromoter', formData.chiefPromoter);
        formDataToSend.append('designation', formData.designation);
        formDataToSend.append('yearOfIncorporation', formData.yearOfIncorporation);
        formDataToSend.append('areasOfOperation', formData.areasOfOperation);
        formDataToSend.append('attendAwards', formData.attendAwards);
        formDataToSend.append('willingToSupplement', formData.willingToSupplement);
        formDataToSend.append('willingToPresent', formData.willingToPresent);
        formDataToSend.append('writeUp', formData.writeUp);
        formDataToSend.append('otherInfo', formData.otherInfo);

        // Convert boolean values to integers (1 for true, 0 for false)
        formDataToSend.append('statutoryApprovals', formData.legalCompliance.statutoryApprovals ? '1' : '0');
        formDataToSend.append('noPFTaxLiabilities', formData.legalCompliance.noPFTaxLiabilities ? '1' : '0');
        formDataToSend.append('noOffences', formData.legalCompliance.noOffences ? '1' : '0');
        formDataToSend.append('notNPA', formData.legalCompliance.notNPA ? '1' : '0');
        formDataToSend.append('noChildEmployment', formData.legalCompliance.noChildEmployment ? '1' : '0');

        formDataToSend.append('applicantName', formData.applicantName);
        formDataToSend.append('applicantDesignation', formData.applicantDesignation);
        formDataToSend.append('applicantEmail', formData.applicantEmail);
        formDataToSend.append('applicantPhone', formData.applicantPhone);

        // Append the signature file if available
        if (signatureFile) {
            formDataToSend.append('signature', signatureFile);
        }

        try {
            const response = await axios.post('https://rvapi.emedha.in/pages/api/api-form1/submit', formDataToSend, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            console.log(response.data);
            alert('Form submitted successfully');
        } catch (error) {
            console.error('Error submitting form:', error);
            alert('Failed to submit form. Please try again.');
        }
    };





    return (
        <>
            <img src={H1} alt="item" className="img-fluid" style={{ height: '200px', width: '100%' }} />

            <div className='container' style={{ marginTop: '50px' }}>
                <h3 style={{ textAlign: 'center', marginBottom: '20px', textTransform: 'uppercase' }}>Declaration Form for Nominations</h3>
                <form onSubmit={handleSubmit}>
                    <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: '15px' }}>
                        <div style={{ flex: '1', marginRight: '15px', marginBottom: '15px' }}>
                            <label><FaRegUser /> Name:</label>
                            <input type="text" name="name" placeholder="Enter Name" value={formData.name} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required />
                        </div>
                        <div style={{ flex: '1', marginBottom: '15px' }}>
                            <label><FaRegBuilding /> Address:</label>
                            <input type="text" name="address" placeholder="Enter Address" value={formData.address} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required />
                        </div>
                    </div>

                    <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: '15px' }}>
                        <div style={{ flex: '1', marginRight: '15px', marginBottom: '15px' }}>
                            <label><FaPhoneAlt /> Phone:</label>
                            <input type="text" name="phone" placeholder="Enter Phone" value={formData.phone} maxLength={10} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required />
                        </div>
                        <div style={{ flex: '1', marginBottom: '15px' }}>
                            <label><FaEnvelope /> Email:</label>
                            <input type="email" name="email" placeholder="Enter Email" value={formData.email} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required />
                        </div>
                    </div>

                    <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: '15px' }}>
                        <div style={{ flex: '1', marginRight: '15px', marginBottom: '15px' }}>
                            <label><FaPen /> Chief Promoter Name:</label>
                            <input type="text" name="chiefPromoter" placeholder="Enter Chief Promoter Name" value={formData.chiefPromoter} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required />
                        </div>
                        <div style={{ flex: '1', marginBottom: '15px' }}>
                            <label><FaPen /> Designation:</label>
                            <input type="text" name="designation" placeholder="Enter Designation" value={formData.designation} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required />
                        </div>
                    </div>

                    <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: '15px' }}>
                        <div style={{ flex: '1', marginRight: '15px', marginBottom: '15px' }}>
                            <label><FaRegFileAlt /> Year of Incorporation:</label>
                            <input type="text" name="yearOfIncorporation" value={formData.yearOfIncorporation} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required />
                        </div>
                        <div style={{ flex: '1', marginBottom: '15px' }}>
                            <label><FaRegFileAlt /> Areas of Operation:</label>
                            <input type="text" name="areasOfOperation" value={formData.areasOfOperation} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required />
                        </div>
                    </div>

                    <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: '15px' }}>
                        <div style={{ flex: '1', marginRight: '15px', marginBottom: '15px' }}>
                            <label><FaCheckCircle /> If selected, will you attend to the awards function to accept the award:</label>
                            <select name="attendAwards" value={formData.attendAwards} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required>
                                <option value="">select</option>
                                <option value="YES">YES</option>
                                <option value="NO">NO</option>
                            </select>
                        </div>
                        <div style={{ flex: '1', marginBottom: '15px' }}>
                            <label><FaCheckCircle /> Are you willing to supplement any further information?</label>
                            <select name="willingToSupplement" value={formData.willingToSupplement} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required>
                                <option value="">select</option>
                                <option value="YES">YES</option>
                                <option value="NO">NO</option>
                            </select>
                        </div>
                    </div>

                    <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: '15px' }}>
                        <div style={{ flex: '1', marginRight: '15px', marginBottom: '15px' }}>
                            <label><FaCheckCircle /> Are you willing to make a presentation before the jury?</label>
                            <select name="willingToPresent" value={formData.willingToPresent} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required>
                                <option value="">select</option>
                                <option value="YES">YES</option>
                                <option value="NO">NO</option>
                            </select>
                        </div>
                    </div>

                    <div style={{ marginBottom: '15px' }}>
                        <label><FaRegFileAlt /> Write a brief 200-word write-up on why you consider yourself suitable for this Award:</label>
                        <textarea name="writeUp" value={formData.writeUp} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} rows="4" required />
                    </div>

                    <div style={{ marginBottom: '15px' }}>
                        <label><FaRegFileAlt /> Any other relevant information in support of the proposal:</label>
                        <textarea name="otherInfo" value={formData.otherInfo} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} rows="4" />
                    </div>

                    <div style={{ marginBottom: '15px' }}>
                        <label><FaShieldAlt /> Legal & Statutory compliance:</label>
                        <div style={{ border: '2px solid #000', padding: '15px', borderRadius: '5px', backgroundColor: '#f8f9fa' }}>
                            <label>
                                <input type="checkbox" name="statutoryApprovals" checked={formData.legalCompliance.statutoryApprovals} onChange={handleCheckboxChange} />
                                <FaShieldAlt /> Has all Statutory approvals
                            </label>
                            <br />
                            <label>
                                <input type="checkbox" name="noPFTaxLiabilities" checked={formData.legalCompliance.noPFTaxLiabilities} onChange={handleCheckboxChange} />
                                <FaShieldAlt /> No PF/Tax liabilities
                            </label>
                            <br />
                            <label>
                                <input type="checkbox" name="noOffences" checked={formData.legalCompliance.noOffences} onChange={handleCheckboxChange} />
                                <FaShieldAlt /> Not involved in any Civil/Criminal/Economic offences
                            </label>
                            <br />
                            <label>
                                <input type="checkbox" name="notNPA" checked={formData.legalCompliance.notNPA} onChange={handleCheckboxChange} />
                                <FaShieldAlt /> Not an NPA with Banks/FI
                            </label>
                            <br />
                            <label>
                                <input type="checkbox" name="noChildEmployment" checked={formData.legalCompliance.noChildEmployment} onChange={handleCheckboxChange} />
                                <FaShieldAlt /> No Child employment
                            </label>
                        </div>
                    </div>

                    <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: '15px' }}>
                        <div style={{ flex: '1', marginRight: '15px', marginBottom: '15px' }}>
                            <label><FaRegUser /> Name of Applicant:</label>
                            <input type="text" name="applicantName" value={formData.applicantName} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required />
                        </div>
                        <div style={{ flex: '1', marginBottom: '15px' }}>
                            <label><FaPen /> Designation (CEO/MD/Chief Promoter):</label>
                            <input type="text" name="applicantDesignation" value={formData.applicantDesignation} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required />
                        </div>
                    </div>

                    <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: '15px' }}>
                        <div style={{ flex: '1', marginRight: '15px', marginBottom: '15px' }}>
                            <label><FaEnvelope /> Email ID:</label>
                            <input type="email" name="applicantEmail" value={formData.applicantEmail} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required />
                        </div>
                        <div style={{ flex: '1', marginBottom: '15px' }}>
                            <label><FaPhoneAlt /> Phone/Mobile:</label>
                            <input type="text" name="applicantPhone" value={formData.applicantPhone} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required />
                        </div>
                    </div>

                    <div style={{ marginBottom: '15px' }}>
                        <label><FaRegFileAlt /> Signature of Applicant and Company seal:</label>
                        <input type="file" name="signature" accept="image/*" onChange={handleSignatureChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required />
                    </div>

                    <div className='mb-2' style={{ textAlign: 'center' }}>
                        <button className="btn btn-primary w-100">Submit</button>
                    </div>
                </form>
            </div>

            <footer style={{ backgroundColor: '#f1f1f1', padding: '20px 0', textAlign: 'center', marginTop: 'auto' }}>
                <div>
                    <p style={{ margin: '0', fontSize: '14px' }}>
                        Powered by
                        <a href="https://emedha.com/" target="_blank" rel="noopener noreferrer" style={{ color: '#4CAF50', textDecoration: 'none', marginLeft: '5px', }}>
                            EMedha Technologies
                        </a>
                    </p>
                    <a href="https://emedha.com/" target="_blank" rel="noopener noreferrer">
                        <img src={L1} alt="EMedha Technologies Logo" style={{ width: '200px', height: 'auto', marginTop: '10px' }} />
                    </a>
                </div>
            </footer>
        </>
    );
};

export default Form1;
